module.exports = __webpack_public_path__ + "media/target_area_icon/dept_corporate-474e835c.png";